export const StudioIcon = ({ fill }) => {
  return (
    <svg
      width="29"
      height="22"
      viewBox="0 0 29 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.693281 0H24.7956C25.1768 0 25.4877 0.310957 25.4877 0.692715V2.31434H24.5815V1.60123C24.5815 1.26535 24.3079 0.989512 23.9697 0.989512H1.5208C1.18379 0.989512 0.906816 1.26365 0.908516 1.60123V14.0962C0.908516 14.432 1.18436 14.7084 1.5208 14.7084H19.5235V17.353H0.693281C0.311523 17.353 0 17.0415 0 16.6603V0.692715C0 0.310957 0.311523 0 0.693281 0ZM21.8089 3.72809H28.1323C28.6092 3.72809 29 4.11834 29 4.59639V18.5827C29 19.0601 28.6092 19.4504 28.1323 19.4504H21.8089C21.3314 19.4504 20.9412 19.0601 20.9412 18.5827V4.59639C20.9412 4.11834 21.3314 3.72809 21.8089 3.72809ZM26.8335 7.38877H27.6321V7.6799H26.8335V7.38877ZM24.97 15.8577C25.4905 15.8577 25.9131 16.2808 25.9131 16.8007C25.9131 17.3218 25.4905 17.7444 24.97 17.7444C24.4495 17.7444 24.0264 17.3218 24.0264 16.8007C24.0281 16.2808 24.4495 15.8577 24.97 15.8577ZM22.1165 6.56635H27.8247C27.925 6.56635 28.006 6.64848 28.006 6.74703V7.86228C28.006 7.96141 27.9238 8.04297 27.8247 8.04297H22.1165C22.0156 8.04297 21.9352 7.96141 21.9352 7.86228V6.74703C21.9354 6.69906 21.9545 6.6531 21.9885 6.61923C22.0225 6.58537 22.0685 6.56635 22.1165 6.56635ZM9.60172 18.3091H15.8866C15.903 19.396 16.351 20.3708 17.5643 21.136H7.92402C8.89428 20.4331 9.60625 19.5784 9.60172 18.3091Z"
        fill={fill}
      />
    </svg>
  );
};
